export default {
    path: 'download_file',
    component: () => import('@/pages/download_file/Index'),
    meta: { title: '下载记录' },
    children: []
}
